"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { buyerProtectionEnquireFormConfig } from './BuyerProtectionEnquireFormConfig';

export const BuyerProtectionEnquireForm = () => {
  return (
    <MultiStepForm 
      config={buyerProtectionEnquireFormConfig}
    />
  );
};

export default BuyerProtectionEnquireForm;
